import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Date$now from "@babel/runtime-corejs2/core-js/date/now";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _Array$from from "@babel/runtime-corejs2/core-js/array/from";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import createRef from '@roo/create-react-ref/createRef';
import classNames from 'classnames';
import { isFunction } from '@utiljs/is';
import { uploadFile } from '../_utils/Upload';
import FileShowCard from './FileShowCard';
import FileShowList from './FileShowList';

var Upload = /*#__PURE__*/function (_React$Component) {
  _inherits(Upload, _React$Component);

  var _super = _createSuper(Upload);

  function Upload() {
    var _this;

    _classCallCheck(this, Upload);

    _this = _super.apply(this, arguments); // @ts-ignore
    // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      fileList: [],
      dragState: false
    };
    _this.ajaxQueue = {};
    _this.inputRef = createRef();

    _this.triggerChangeEvent = function (files) {
      var fileList = _this.state.fileList;
      var postFiles = Array.prototype.slice.call(files);
      if (postFiles.length === 0) return; // @ts-ignore

      var formatFileList = postFiles.map(function (file) {
        return _this.formatFile(file);
      });
      var onChange = _this.props.onChange;
      var newFileList = [].concat(_toConsumableArray(fileList), _toConsumableArray(formatFileList));

      _this.setState({
        fileList: newFileList
      }, function () {
        postFiles.forEach(function (file) {
          if (onChange && isFunction(onChange)) {
            onChange(file, newFileList, {
              name: 'init'
            });
          }

          _this.uploadSingleFile(file);
        });
      });
    };

    _this.handlePreview = function (file) {
      var onPreview = _this.props.onPreview;

      if (typeof onPreview === 'function') {
        onPreview(file);
      }
    };
    /**
     * 文件状态改变回调
     */


    _this.change = function (event) {
      var files = event.target.files;
      if (!files) return; // @ts-ignore

      _this.upLoadFiles(_Array$from(files));

      _this.clearTargetVal(event);
    };

    _this.clearTargetVal = function (event) {
      event.target.value = '';
    };

    _this.upLoadFiles = function (files) {
      var fileList = _this.state.fileList;
      var validityCallback = _this.props.validityCallback;

      if (!validityCallback || typeof validityCallback !== 'function') {
        _this.triggerChangeEvent(files);

        return;
      }

      var validResult = validityCallback(files, fileList);
      if (validResult === false) return; // 返回promise

      if (typeof validResult.then === 'function') {
        // eslint-disable-next-line no-unused-expressions
        _typeof(validResult.then(function (canUpload) {
          if (canUpload !== false) {
            _this.triggerChangeEvent(files);
          }
        }));

        return;
      }

      _this.triggerChangeEvent(files);
    };
    /**
     * 清空dom挂载的file
     */


    _this.clearFileData = function () {
      if (!_this.inputRef) return;
      var current = _this.inputRef.current;
      if (!current) return;
      current.value = '';
    };

    _this.uploadSingleFile = function (file) {
      var beforeUpload = _this.props.beforeUpload;

      if (!beforeUpload) {
        _this.post(file);

        return;
      }

      var before = beforeUpload(file);

      if (typeof before !== 'boolean' && before && before.then) {
        before.then(function (isValid) {
          if (isValid !== false) {
            _this.post(file);
          }
        });
      } else if (before !== false) {
        _this.post(file);
      }
    };

    _this.formatFile = function (file) {
      file.uid = "".concat(_Date$now(), "-").concat(Math.floor(Math.random() * 100), "-").concat(Math.floor(Math.random() * 100));
      return {
        status: 'init',
        name: file.name,
        size: file.size,
        percentage: 0,
        uid: file.uid,
        showProgress: true,
        _fileObj: file
      };
    };

    _this.getFile = function (file) {
      var fileList = _this.state.fileList;
      var target = null;
      fileList.forEach(function (item) {
        if (file.uid === item.uid) {
          target = item;
        }
      });
      return target;
    };

    _this.onFileRemove = function (file) {
      var fileList = _this.state.fileList;
      var _this$props = _this.props,
          onRemove = _this$props.onRemove,
          onChange = _this$props.onChange; // @ts-ignore

      var targetIndex = fileList.findIndex(function (f) {
        return f.uid === file.uid;
      }); // @ts-ignore

      var _file = fileList.splice(targetIndex, 1);

      _this.setState({
        fileList: fileList
      }, function () {
        if (onChange && isFunction(onChange)) {
          onChange(_file[0], fileList, {
            name: 'fail'
          });
        }

        if (onRemove && isFunction(onRemove)) {
          onRemove(_file[0], fileList);
        } // @ts-ignore


        if (_this.ajaxQueue[file.uid]) {
          // @ts-ignore
          _this.ajaxQueue[file.uid].abort(); // @ts-ignore


          delete _this.ajaxQueue[file.uid];
        }
      });
    };

    _this.post = function (file) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          headers = _this$props2.headers,
          withCredentials = _this$props2.withCredentials,
          action = _this$props2.action,
          uploadParams = _this$props2.uploadParams;
      if (!file || !action) return;
      var ajaxInStance = uploadFile({
        header: headers,
        withCredentials: withCredentials,
        // @ts-ignore
        file: file,
        data: uploadParams,
        fileName: name,
        action: action,
        onProgress: function onProgress(e) {
          _this.handleProgress(e, file);
        },
        onSuccess: function onSuccess(res) {
          _this.handleSuccess(res, file);
        },
        onError: function onError(err) {
          _this.handleError(err, file);
        }
      }); // @ts-ignore

      _this.ajaxQueue[file.uid] = ajaxInStance;
    };

    _this.handleError = function (err, file) {
      var _file = _this.getFile(file);

      if (!_file) return;
      var fileList = _this.state.fileList;
      var _this$props3 = _this.props,
          onFail = _this$props3.onFail,
          onChange = _this$props3.onChange;
      _file.status = 'fail';
      _file.errorInfo = err.message;

      _this.setState({
        fileList: fileList
      });

      if (onFail && typeof onFail === 'function') {
        onFail(err, _file, fileList);
      }

      if (onChange && typeof onChange === 'function') {
        onChange(_file, fileList, {
          name: 'fail'
        });
      }
    };

    _this.handleProgress = function (e, file) {
      var _this$props4 = _this.props,
          onProgress = _this$props4.onProgress,
          onChange = _this$props4.onChange;
      var fileList = _this.state.fileList; // @ts-ignore

      var _file = _this.getFile(file);

      if (!_file) return;

      if (onProgress && typeof onProgress === 'function') {
        onProgress(e, _file, fileList);
      } // @ts-ignore


      _file.percent = e.percent || 0;
      _file.status = 'uploading';

      if (onChange && typeof onChange === 'function') {
        onChange(_file, fileList, {
          name: 'uploading'
        });
      }

      _this.setState({
        fileList: fileList
      });
    };

    _this.triggerNativeClick = function () {
      if (!_this.inputRef || !_this.inputRef.current) return;

      _this.inputRef.current.click();
    };

    _this.onDrop = function (e) {
      e.preventDefault();

      _this.setState({
        dragState: e.type === 'dragover'
      });

      if (e.type !== 'drop' || _this.props.disabled || !_this.props.canDrop) return;
      var files = e.dataTransfer.files; // @ts-ignore

      _this.upLoadFiles(files);
    };

    _this.renderLoader = function () {
      var _this$props5 = _this.props,
          accept = _this$props5.accept,
          disabled = _this$props5.disabled,
          multiple = _this$props5.multiple,
          children = _this$props5.children,
          canDrop = _this$props5.canDrop;
      if (children === null) return null;
      var dragState = _this.state.dragState;
      return /*#__PURE__*/React.createElement("div", {
        onChange: _this.change,
        onDrop: _this.onDrop,
        onDragOver: _this.onDrop,
        onDragLeave: _this.onDrop,
        className: classNames('roo-upload-load', {
          'roo-upload-load-canDrop': canDrop
        }, {
          'roo-upload-load-dropover': dragState && !disabled && canDrop
        })
      }, /*#__PURE__*/React.createElement("label", {
        onClick: _this.triggerNativeClick
      }, children), /*#__PURE__*/React.createElement("input", {
        ref: _this.inputRef,
        type: "file",
        accept: accept,
        style: {
          display: 'none'
        },
        disabled: disabled,
        multiple: multiple
      }));
    };

    _this.renderShowList = function () {
      var _this$props6 = _this.props,
          showType = _this$props6.showType,
          showUploadList = _this$props6.showUploadList,
          disabled = _this$props6.disabled,
          canDrop = _this$props6.canDrop,
          onPreview = _this$props6.onPreview,
          renderCustomCard = _this$props6.renderCustomCard,
          customCardClassName = _this$props6.customCardClassName;
      var isShowPreview = typeof onPreview === 'function';
      var fileList = _this.state.fileList;
      if (!showUploadList) return _this.renderLoader();

      if (showType === 'card') {
        return /*#__PURE__*/React.createElement(FileShowCard, {
          canDrop: canDrop,
          onPreview: _this.handlePreview,
          renderCustomCard: renderCustomCard,
          customCardClassName: customCardClassName,
          isShowPreview: isShowPreview,
          disabled: disabled,
          fileList: fileList,
          renderLoader: _this.renderLoader,
          onFileRemove: _this.onFileRemove
        });
      }

      if (showType === 'list') {
        return /*#__PURE__*/React.createElement(FileShowList, {
          disabled: disabled,
          fileList: fileList,
          isShowPreview: isShowPreview,
          onPreview: _this.handlePreview,
          renderLoader: _this.renderLoader,
          onFileRemove: _this.onFileRemove
        });
      }

      return _this.renderLoader();
    };

    return _this;
  }

  _createClass(Upload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        fileList: this.props.defaultFileList || []
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(res, file) {
      var _file = this.getFile(file);

      var fileList = this.state.fileList;
      var _this$props7 = this.props,
          onSuccess = _this$props7.onSuccess,
          onChange = _this$props7.onChange,
          onFail = _this$props7.onFail;
      if (!_file) return;

      if (onSuccess && typeof onSuccess === 'function') {
        // @ts-ignore
        if (onSuccess(res, _file, fileList) === false) {
          _file.status = 'fail';
          _file.response = res;

          if (onChange && typeof onChange === 'function') {
            onChange(_file, fileList, {
              name: 'fail'
            });
          }

          if (onFail && typeof onFail === 'function') {
            onFail(res, _file, fileList);
          }

          this.setState({
            fileList: fileList
          });
          return;
        }
      }

      _file.status = 'success';
      _file.response = res;

      if (onChange && typeof onChange === 'function') {
        onChange(_file, fileList, {
          name: 'success'
        });
      }

      this.setState({
        fileList: fileList
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          className = _this$props8.className,
          style = _this$props8.style;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-container ".concat(className || '', " "),
        style: style
      }, this.renderShowList());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var _props$defaultFileLis = props.defaultFileList,
          defaultFileList = _props$defaultFileLis === void 0 ? [] : _props$defaultFileLis,
          fileList = props.fileList;
      if (!fileList) return null;
      return {
        preProps: props,
        fileList: [].concat(_toConsumableArray(defaultFileList), _toConsumableArray(fileList))
      };
    }
  }]);

  return Upload;
}(React.Component);

Upload.defaultProps = {
  showType: '',
  multiple: false,
  showUploadList: false,
  canDrop: false,
  headers: {},
  action: '',
  accept: '',
  disabled: false,
  defaultFileList: [],
  fileList: null,
  uploadParams: {},
  name: 'file',
  withCredentials: false,
  validityCallback: null,
  onChange: null,
  onRemove: null,
  beforeUpload: null,
  onSuccess: null,
  onPreview: null,
  onProgress: null,
  onFail: null
};
Upload.propTypes = {
  showType: PropTypes.string,
  multiple: PropTypes.bool,
  showUploadList: PropTypes.bool,
  canDrop: PropTypes.bool,
  headers: PropTypes.object,
  action: PropTypes.string,
  accept: PropTypes.string,
  disabled: PropTypes.bool,
  defaultFileList: PropTypes.array,
  fileList: PropTypes.array,
  uploadParams: PropTypes.object,
  name: PropTypes.string,
  withCredentials: PropTypes.bool,
  validityCallback: PropTypes.func,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  beforeUpload: PropTypes.func,
  onSuccess: PropTypes.func,
  onProgress: PropTypes.func,
  onPreview: PropTypes.func,
  onFail: PropTypes.func
}; // @ts-ignore

polyfill(Upload);
export default Upload;